module.exports = __webpack_public_path__ + "1463d298a88ad06fd578f77dbb26de5c.png";